/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import IsSubmitting from './IsSubmitting/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Loading"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payersValueData = fromData.useDataValue({ viewPath,
context: 'payers',
})
fromData.useSetFlowToBasedOnDataIsSubmitting({ viewPath,
context: 'payers',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IsSubmitting'}>
<IsSubmitting
  viewPath={`${viewPath}/IsSubmitting`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}